import type { ReactNode } from 'react'
import { Tooltip } from 'uikit/tooltips/default'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Flex } from 'uikit/layout/default'
import styles from '../controls.module.scss'

export interface PropertyFieldProps {
  label: string
  tooltip?: string
  extra?: ReactNode
  children: ReactNode
}

export function PropertyField({ label, tooltip, extra, children }: PropertyFieldProps) {
  return (
    <Flex className={styles.propertyField}>
      <Flex className={styles.propertyLabel}>
        <span>{label}</span>
        {tooltip && (
          <Tooltip title={tooltip}>
            <InfoCircleOutlined className={styles.cursorHelp} />
          </Tooltip>
        )}
        {extra}
      </Flex>
      {children}
    </Flex>
  )
}
